import { combineReducers } from '@reduxjs/toolkit'
import selected from './selected'
import showCurrencyWarning from './showCurrencyWarning'

const currency = combineReducers({
  selected,
  showCurrencyWarning,
})

export type Currency = ReturnType<typeof currency>

export default currency
